import ImpressionEvent, { type ImpressionType } from './ImpressionEvent';

export type ModuleDisplayType = 'block' | 'carousel' | 'full-bleed' | 'grid';

export type ModuleImpressionProperties = {
  column_count?: number;
  display_type?: ModuleDisplayType;
  item_count?: number;
  module_position?: number;
  module_type: string;
};

type EventData = {
  columnCount?: number;
  displayType?: ModuleDisplayType;
  guestId?: string;
  isBot: boolean;
  itemCount?: number;
  modulePosition?: number;
  moduleType: string;
};

class ModuleImpressionEvent extends ImpressionEvent<
  EventData,
  ModuleImpressionProperties
> {
  protected get impressionType(): ImpressionType {
    return 'module';
  }

  protected getImpressionProperties(): ModuleImpressionProperties {
    return {
      column_count: this.data.columnCount,
      display_type: this.data.displayType,
      item_count: this.data.itemCount,
      module_position: this.data.modulePosition,
      module_type: this.data.moduleType
    };
  }
}

export default ModuleImpressionEvent;
